<template>
  <div v-if="$site?.location" class="overflow-x-hidden">
    <template v-if="isBot">
      <LayoutBot>
        <NuxtPage/>
      </LayoutBot>
    </template>

    <template v-else-if="isWidget">
      <LayoutWidget>
        <NuxtPage/>
      </LayoutWidget>
    </template>

    <template v-else-if="isApp">
      <LayoutBookApp>
        <NuxtPage/>
      </LayoutBookApp>
    </template>

    <template v-else-if="isFacebook">
      <LayoutWidget>
        <NuxtPage/>
      </LayoutWidget>
    </template>

    <template v-else>
      <LayoutWeb>
        <NuxtPage/>
      </LayoutWeb>
    </template>

    <UNotifications />

    <div id="teleports" class="bottom-16 fixed w-full z-20" />
  </div>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk;
  }
})

defineOgImageComponent('Preview')

useSiteHead()

const layoutStore = useLayoutStore()

const isBot = computed(() => {
  return layoutStore.layout === 'bot'
})

const isWidget = computed(() => {
  return layoutStore.layout === 'widget'
})

const isApp = computed(() => {
  return layoutStore.layout === 'app'
})

const isFacebook = computed(() => {
  return layoutStore.layout === 'facebook'
})
</script>